import React from 'react';
import BakingClass from '../../components/BakingClass';
import Menu from '../../components/MenuElements/Menu';
import SubMenu from '../../components/MenuElements/SubMenu';
import Takeout from '../../components/MenuElements/Takeout';
import Clients from '../../components/common/Clients';
import Timeline from '../../components/common/Timeline';
import Video from '../../components/common/Video';
import AboutUs from '../../containers/AboutUs';
import AllSlider from '../../containers/AllSlider';
import BlogHome from '../../containers/BlogHome';
import ContactUs from '../../containers/ContactUs';
import Div from '../../containers/Div';
import SpecialityContainer from '../../containers/SpecialityContainer';

const Home = () => {
    return (
        <div className="main-wrapper pt_0">
            <AllSlider />
            <AboutUs />
            <Video />
            <Menu />
            <SubMenu />
            <SpecialityContainer />
            <Div />
            <BakingClass />
            <BlogHome />
            <Timeline />
            <Clients />
            <Takeout />
            <ContactUs />
        </div>
    );
};

export default Home;